import { CustomerOrganizationType } from '../../api/organization/organizationApiTypes';

/**
 * i18n key per customer-organization type. Reuses the existing
 * `organization_type.*` labels where they map (club → association / Verein,
 * public_body → municipality / Kommune, company → company); `other` is a new
 * key under the `organization.type_options` namespace. See plan §6.2.
 *
 * Shared by the form's type select and the list column so the mapping lives in
 * one place (no duplication).
 */
export const ORGANIZATION_TYPE_LABEL_KEY: Record<CustomerOrganizationType, string> = {
    club: 'organization_type.association',
    company: 'organization_type.company',
    public_body: 'organization_type.municipality',
    other: 'organization.type_options.other',
};
